module.exports = __webpack_public_path__ + "static/enable-figma-library-b-96715abcef35903941a2e08734ab8057.png";